import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import {
	ITableState,
	TableResponseModel,
} from "../../../services/crud-table/models/table.model";
import { PaginatorState } from "../../../services/crud-table/models/paginator.model";
import { GroupingState } from "../../../services/crud-table/models/grouping.model";
import { ROUTES } from "../../../constants";
import { UtilityService } from "../../../services/utility.service";
import { BuyerTenderDetailModel, BuyerTenderModel, BuyerTenderProductDetailsModel } from "../models/buyer-tender.model";
import { BaseService } from "src/app/services/base.service";
import { TranslateService } from "@ngx-translate/core";

const DEFAULT_STATE: ITableState = {
	filter: {},
	paginator: new PaginatorState(),
	sorting: {
		column: "deadLineDate",
		direction: "desc",
	},
	searchTerm: "",
	grouping: new GroupingState(),
};

@Injectable({
	providedIn: "root",
})
export class BuyerTenderService<T> extends BaseService<T> {
	private emptyTender = {
		attachments: [],
		buyerId: '',
		buyerOrganizationId: '',
		deadLineDate: '',
		deliveryAddress: [],
		description: '',
		id: '',
		name: '',
		notes: '',
		products: [],
		quotations: [],
		status: '',
		tenderId: '',
		_id: '',
		_v: 0,
	}

	currentLanguage: string;
	constructor(
		private translateService: TranslateService,
		private utilityService: UtilityService,
		@Inject(HttpClient) http
	) {
		super(http);
		this.tableState = {
			filter: {},
			paginator: new PaginatorState(),
			sorting: {
				column: "deadLineDate",
				direction: "desc",
			},
			searchTerm: "",
			grouping: new GroupingState(),
		};
		this.currentLanguage = this.translateService.currentLang;
		this.translateService.onLangChange.subscribe(response => {
			this.currentLanguage = response.lang;
		});
		this.tableState.paginator.pageSize = 10;
	}

	private _total$: BehaviorSubject<number> = new BehaviorSubject(0);

	get total$() {
		return this._total$.asObservable();
	}

	private _buyersFromTenders$: BehaviorSubject<any> = new BehaviorSubject([]);

	get buyersFromTenders$() {
		return this._buyersFromTenders$.asObservable();
	}

	private _tender$: BehaviorSubject<any> = new BehaviorSubject(this.emptyTender);

	get tender$() {
		return this._tender$.asObservable();
	}

	private _tenders$: BehaviorSubject<T[]> = new BehaviorSubject([]);

	get tenders$() {
		return this._tenders$.asObservable();
	}

	private _draftTenders$: BehaviorSubject<T[]> = new BehaviorSubject([]);

	get draftTenders$() {
		return this._draftTenders$.asObservable();
	}

	private _categories$: BehaviorSubject<any> = new BehaviorSubject([]);

	get categories$() {
		return this._categories$.asObservable();
	}

	private _tenderRequestLog$: BehaviorSubject<any> = new BehaviorSubject([]);

	get tenderRequestLog$(){
		return this._tenderRequestLog$.asObservable();
	}

	// private _privateTenderInfo$: BehaviorSubject<any> = new BehaviorSubject({});

	// get privateTenderInfo$() {
	// 	return this._privateTenderInfo$;
	// }

	// private _tenderStatus$: BehaviorSubject<any> = new BehaviorSubject({});

	// get tenderStatus$() {
	// 	return this._tenderStatus$;
	// }

	// private _selectedProducts$: BehaviorSubject<any> = new BehaviorSubject([]);

	// get selectedProducts$() {
	// 	return this._selectedProducts$;
	// }

	// private _selectedCategory$: BehaviorSubject<any> = new BehaviorSubject({});

	// get selectedCategory$() {
	// 	return this._selectedCategory$;
	// }

	// private _nullVoumeProduct$ = new BehaviorSubject([]);

	// get nullVoumeProduct$() {
	// 	return this._nullVoumeProduct$;
	// }

	// private _attachments$ = new BehaviorSubject([]);

	// get attachments$() {
	// 	return this._attachments$;
	// }

	// private _productAttachments$ = new BehaviorSubject([]);

	// get productAttachments$() {
	// 	return this._productAttachments$;
	// }

	// private _deliveryAddress$: BehaviorSubject<any> = new BehaviorSubject({});

	// get deliveryAddress$() {
	// 	return this._deliveryAddress$;
	// }

	// private _paymentInfo$: BehaviorSubject<any> = new BehaviorSubject({});

	// get paymentInfo$() {
	// 	return this._paymentInfo$;
	// }

	// private _deadlineData$: BehaviorSubject<any> = new BehaviorSubject({});

	// get deadlineData$() {
	// 	return this._deadlineData$;
	// }

	private _subsciptionModalVisible$: BehaviorSubject<boolean> = new BehaviorSubject(false);

	get subsciptionModalVisible$() {
		return this._subsciptionModalVisible$.asObservable();
	}

	// private _extractionPath$: BehaviorSubject<string> = new BehaviorSubject('');

	// get extractionPath$() {
	// 	return this._extractionPath$.asObservable();
	// }

	// setExtractionPath(path: string) {
	// 	this._extractionPath$.next(path);
	// }

	// private _tenderShortId$: BehaviorSubject<string> = new BehaviorSubject('');

	// get tenderShortId$(){
	// 	return this._tenderShortId$.asObservable();
	// }

	// setTenderShortId(id){
    //     this._tenderShortId$.next(id);
	// }

	setSubscriptionModalVisibility(isVisible) {
		this._subsciptionModalVisible$.next(isVisible);
	}

	resetDefaultState(): void {
		this.findTenderss(DEFAULT_STATE);
	}

	// setTenderStatus(tenderInfo) {
	// 	this._tenderStatus$.next(tenderInfo);
	// }

	// setSelectedProducts(products) {
	// 	this._selectedProducts$.next(products);
	// }

	// setSelectedCategory(category) {
	// 	this._selectedCategory$.next(category);
	// }

	// setAttachments(attachments) {
	// 	this._attachments$.next(attachments);
	// }

	// setProductAttachments(attachments) {
	// 	this._productAttachments$.next(attachments);
	// }

	// setDeliveryAddresses(addressData) {
	// 	this._deliveryAddress$.next(addressData);
	// }

	// setPaymentInfo(paymentData) {
	// 	this._paymentInfo$.next(paymentData);
	// }

	// setDeadlineData(deadlineData) {
	// 	this._deadlineData$.next(deadlineData);
	// }

	// setPrivateTenderInfo(tenderInfo) {
	// 	this._privateTenderInfo$.next(tenderInfo);
	// }

	/**
	 * Handle create tender functionality
	 * @param tenderData : tender's data
	 * @returns
	 */
	placeTender(tenderData): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.CREATE;
		return this.create(tenderData, url);
	}

	/**
	 * Edit tender
	 */
	editTender(tenderData, id): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.EDIT + "/" + id;
		return this.put(url, tenderData, this.currentLanguage);
	}

	/**
	 * send invitation
	 * @param tenderData 
	 * @param id 
	 * @returns 
	 */
	sendTenderInvitation(tenderData, id): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.INVITATION_MAIL + "/" + id;
		return this.post(url, tenderData, this.currentLanguage);
	}

	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	 */
	findNewestTenders(): void {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH;
		this.tableState.paginator.pageSize = 5;
		this.tableState.sorting.column = "createdAt";
		this.tableState.sorting.direction = "desc";
		this.post(url, this.tableState).subscribe((res: TableResponseModel<T>) => {
			this._tenders$.next(res.items);
			this._total$.next(res.total);
		});
	}


	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	 */
	findTenderss(tableState): void {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH;
		this.post(url, tableState).subscribe((res: TableResponseModel<T>) => {
			this._tenders$.next(res.items);
			this._total$.next(res.total);
		});
	}

	/**
	 * Get Tender Details by Id
	 * @param id :string Id of tender
	 * @returns
	 */
	getTender(tenderId: string): void {
		const url =
			this.API_URL +
			this.VERSION_V1 +
			this.API_ROUTES.BUYER.TENDERS.SEARCH +
			"/" +
			tenderId + '/find';
		this.getById(url, tenderId).subscribe((res: BuyerTenderDetailModel) => {
			this._tender$.next(res);
		});
	}

	/**
	 * Get all categories
	 */
	fetchCategories(sorting?): Observable<any> {
		const url =
			this.API_URL +
			this.VERSION_V1 +
			this.API_ROUTES.BUYER.CATEGORY.SEARCH;
		return this.post(url, { paginator: {}, searchTerm: "", sorting }, this.currentLanguage);
	}

	/**
	 * Get buyer organisation from tenders as unique values for e.g. filters
	 */
	getBuyerOrganizations(tenders): void {
		const uniqueBuyer = [];

		tenders.map((tender) => {
			const index = uniqueBuyer.findIndex(
				(buyer) => buyer?.value === tender?.buyerOrganizationId
			);
			index === -1
				? uniqueBuyer.push({
					label: tender?.buyer?.organizationName,
					value: tender?.buyerOrganizationId,
				})
				: "";
		});
		this._buyersFromTenders$.next(uniqueBuyer);
	}

	public getDetailsRoute(): string {
		return (
			ROUTES.BUYER_ROUTE +
			ROUTES.TENDERS_ROUTE +
			ROUTES.TENDER_PRODUCT_DETAILS_ROUTE
		);
	}

	/**
	 * Handle supplier tender details page redirection
	 */
	public navigationToTendersDetailsPage(tenderId: string): void {
		this.utilityService.navigate(
			ROUTES.BUYER_ROUTE +
			ROUTES.SUPPLIER_TENDERS_ROUTE +
			ROUTES.TENDER_PRODUCT_DETAILS_ROUTE +
			"/" +
			tenderId,
			{ queryParams: { tab: "products" } }
		);
	}

	get _tableState() {
		return this.tableState;
	}

	resetTableState() {
		this.tableState = DEFAULT_STATE;
		this.tableState.paginator.pageSize = 10;
	}

	/**
	 * Get profile
	 */
	getProfile(): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.PROFILE.GET;
		return this.findUser(url);
	}

	/**
	 * upload attachments
	 */
	uploadAttachments(fileData, tenderId: string): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL + `/${tenderId}`
			+ this.API_ROUTES.BUYER.TENDERS.ATTACHMENTS;
		return this.create(fileData, url);
	}

	/**
	 * download attachments
	 */
	downloadAttachment(tenderId: string, fileName: string) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL
			+ `/${tenderId}/attachments?file=${fileName}`;
		this._isLoading$.next(true);
		return this.downloadItems(url, null, this.currentLanguage);
	}

	/*
	 * download own attachments
	 */
	downloadQuotationAttachments(quotationId: string, fileName: string) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.QUOTATIONS.CREATE + `/${quotationId}/attachments?file=${encodeURIComponent(fileName)}`;
		this._isLoading$.next(true);
		return this.downloadItems(url, null, this.currentLanguage);
	}

	/**delete attachments */
	deleteAttachments(tenderId: string, fileName: string) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL
			+ `/${tenderId}/attachments?file=${fileName}`;
		return this.deleteItem(url);
	}

	/**
	 * Handle get tender data by id
	 * @param tenderId : id of the tender
	 */
	getTenderData(tenderId: string): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH + "/" + tenderId
			+ this.API_ROUTES.COMMON.FIND;
		return this.getById(url, tenderId);
	}

	/**
	 * update tender
	 * @param jsonToUpdate
	 * @returns
	 */
	updateTender(id: string, jsonToUpdate: any): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL + `/${id}`;
		return this.put(url, jsonToUpdate);
	}

	/**
	 * Delete tender by ids
	 */
	deleteTender(payload): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.DELETE;
		return this.deleteItems(payload, url);
	}

	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	 */
	findAllProducts(tableState: ITableState): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.PRODUCTS.SEARCH_ALL + "?type=all";
		return this.findItems(url, tableState);
	}

	/**
	 * Create draft order
	 */
	storeDraftTender(tenderData): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.CREATE_DRAFT;
		return this.create(tenderData, url, this.currentLanguage);
	}

	/**
	 * Fetch draft orders
	 */
	findDraftTenders(tenderData): void {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH;
		this.post(url, tenderData).subscribe(response => {
			this._draftTenders$.next(response.items);
			this._totalItems$.next(response.total);
		});
	}

	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	 */
	fetchDeliveries(tableState): Observable<TableResponseModel<any>> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.PROFILE.GET_ADDRESS;
		delete tableState.sorting;
		return this.findAddress(url, tableState);
	}

	/**
	 * Handle tender awarding
	 * @param quotationId : id of the tender
	 */
	awardQuotation(quotationId: string, language: string): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH + `/${quotationId}`
			+ this.API_ROUTES.BUYER.QUOTATIONS.AWARD;
		return this.awardQuotations(url, language);
	}

	/**
	 *	Find by search string
	 * @param tableState : table state parameters
	 * @returns
	 */
	findQuotations(tableState: ITableState): Observable<TableResponseModel<any>> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.QUOTATIONS.SEARCH;
		return this.findItems(url, tableState);
	}

	/**
	 * Handle quotation comparison of a tender
	 * @param tenderId : id of the tender
	 */
	compareQuotations(tenderId: string): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH + `/${tenderId}`
			+ this.API_ROUTES.BUYER.QUOTATIONS.COMPARE;
		return this.findCompareQuotations(url);
	}

	/**
	 * download my attachments of contracts
	 */
	downloadMyContractsAttachments(tenderId: string, fileName: string) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL
			+ `/${tenderId}/attachments?file=${fileName}`;
		this._isLoading$.next(true);
		return this.downloadItems(url, null, this.currentLanguage);
	}

	/**
	 * download supplier's attachments of contracts
	 */
	downloadSuppliersAttachments(quotationId: string, fileName: string) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.QUOTATIONS.CREATE
			+ `/${quotationId}/attachments?file=${fileName}`;
		this._isLoading$.next(true);
		return this.downloadItems(url, null, this.currentLanguage);
	}

	/**
	 *	Find by search string
	 * @param tableState :table state parameters
	 * @returns
	 */
	findTenderProducts(tableState?) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.PRODUCTS.SEARCH;
		return this.patchState(url, tableState);
	}

	/**
	 * Handle item update
	 * @param item : Updated data object
	 * @returns
	 */
	updateTenderProduct(item: BuyerTenderProductDetailsModel): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.PRODUCTS.CREATE + `/${item.id}`;
		return this.put(url, item);
	}

	changeTenderStatus(tender: BuyerTenderModel, statusPayload: { status: string, reason?: string }): Observable<any> {
		const endpoint = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH + "/" + tender.id
			+ this.API_ROUTES.ORDERS.STATUS;
		return this.put(endpoint, statusPayload);
	}

	awardSelectedQuotations(tenderId: string, payload) {
		const endpoint = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SEARCH + "/" + tenderId
			+ this.API_ROUTES.BUYER.QUOTATIONS.AWARD;

		return this.post(endpoint, payload);
	}

	// /**
	//  * Check for null product volume data
	//  */
	// checkForNullEntries(listOfProducts) {
	// 	if (listOfProducts && listOfProducts.length) {
	// 		const nullVolumeProducts = listOfProducts.filter(data => !data.volume);
	// 		this._nullVoumeProduct$.next(nullVolumeProducts);
	// 		return;
	// 	}
	// 	this._nullVoumeProduct$.next([]);
	// }

	getSupplierList(searchTerm) {
		const endpoint = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.SUPPLIERS_LIST;
		this.tableState.paginator.pageSize = 10;
		this.tableState.searchTerm = searchTerm;
		delete this.tableState.sorting;
		return this.post(endpoint, this.tableState);
	}

	/**
	 * copy existing tender with products
	 */
	copyTender (tenderId: string): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL + `/${tenderId}/copy`;
		return this.getById(url,tenderId);
	}

	/*
	 * download all product attachments
	 */
	downloadAllProductAttachments(tenderId: string, productId: string) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL + `/${tenderId}/product/${productId}/attachments/all`;
		return this.downloadItems(url, null, this.currentLanguage);
	}

	/*
	 * download all product attachments
	 */
	downloadProductAttachments(tenderId: string, productId: string, fileName: string) {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL + `/${tenderId}/product/${productId}/attachments?file=${fileName}`;
		return this.downloadItems(url, null, this.currentLanguage);
	}
	/**
	 *  saving new tender creation event
	 */
	saveNewTenderCreationEvent(){
		const url=this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.NEW_TENDER;
		return this.http.get(url);
	}

	/**
	 * Edit Tender Additional Information
	 */
	addTenderAdditionalInformation(tenderData, id): Observable<any> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.EDIT + "/" + id + '/add-info';
		return this.put(url, tenderData, this.currentLanguage);
	}

	/**
     * download Additional Information Attachment File
     */
    downloadAddInfoAttachments(tenderId: string, fileName: string): Observable<Blob> {
        const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.TENDERS.BASE_URL
			+ `/${tenderId}/add-info/attachments?file=${fileName}`;
        return this.downloadItems(url);
    }


	/**
	 *	add categories
	 * @param tableState :table state parameters
	 * @returns
	 */
	addCategories(data: any): Observable<TableResponseModel<T>> {
		const url = this.API_URL + this.VERSION_V1 + this.API_ROUTES.BUYER.ORGANISATION.BASE_URL + this.API_ROUTES.BUYER.ORGANISATION.CATEGORY;
		return this.post(url, data);
	}

	getAndReturnTender(tenderId: string) {
		const url =
			this.API_URL +
			this.VERSION_V1 +
			this.API_ROUTES.BUYER.TENDERS.SEARCH +
			"/" +
			tenderId + '/find';
	
		return this.getById(url, tenderId);
	}
	
	/**
	 * get tender request logs
	 * @param requestLogId
	 * @returns
	 */
	getTenderRequestLogs(requestLogId: string){
		const url =
			this.API_URL +
			this.VERSION_V1 +
			this.API_ROUTES.BUYER.REQUEST_LOGS.GET + "/" + requestLogId;
		return this.getById(url, requestLogId);
	}
}
